import { createSelector } from "reselect";

const selectLogin = (state) => state.login;

export const selectLoginPhoneNumber = createSelector(
  selectLogin,
  (login) => login.phoneNumber
);
export const selectLoginSentCode = createSelector(
  selectLogin,
  (login) => login.sentCode
);

export const selectLoginMelli = createSelector(
  selectLogin,
  (login) => login.melli
);
export const selectLoginName = createSelector(
  selectLogin,
  (login) => login.name
);
export const selectReferralMobile = createSelector(
  selectLogin,
  (login) => login.referralMobile
);
export const selectUserToken = createSelector(
  selectLogin,
  (login) => login.userToken
);
export const selectUserCookie = createSelector(
  selectLogin,
  (login) => login.cookie
);
export const selectSurvey = createSelector(
  selectLogin,
  (login) => login.survey
);

export const selectLoginUsername = createSelector(
  selectLogin,
  (login) => login.userName
);
export const selectLoginPassword = createSelector(
  selectLogin,
  (login) => login.password
);

export const selectLoginStep = createSelector(
  selectLogin,
  (login) => login.step
);

export const selectLoginPhoneNumberIsValid = createSelector(
  selectLogin,
  (login) => login.phoneNumber_isValid
);

export const selectLoginPhoneLoginIsLoading = createSelector(
  selectLogin,
  (login) => login.phoneLogin_isLoading
);
export const selectLoginPhoneLoginConfirmIsLoading = createSelector(
  selectLogin,
  (login) => login.phoneLoginConfirm_isLoading
);
export const selectLoginConfirmMessage = createSelector(
  selectLogin,
  (login) => login.phoneLoginMsg
);
export const selectQueryObject = createSelector(
  selectLogin,
  (login) => login.queryObject
);
